<template>
  <main-header :type="'empty'" />
  <router-view></router-view>
</template>

<script>

import MainHeader from './Header'

export default {
  name: 'MobileEmptyLayout',
  components: {
    MainHeader
  }
}
</script>

<style>

</style>
